var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeadRemind(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F6F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6673 14.6666V16.6666C22.6673 19.3333 21.334 20.6666 18.6673 20.6666H18.334C18.1273 20.6666 17.9273 20.7666 17.8007 20.9333L16.8007 22.2666C16.3607 22.8533 15.6407 22.8533 15.2007 22.2666L14.2007 20.9333C14.094 20.7866 13.8473 20.6666 13.6673 20.6666H13.334C10.6673 20.6666 9.33398 19.9999 9.33398 16.6666V13.3333C9.33398 10.6666 10.6673 9.33325 13.334 9.33325H17.334",
    stroke: "#947BFD",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0007 12.6666C21.9211 12.6666 22.6673 11.9204 22.6673 10.9999C22.6673 10.0794 21.9211 9.33325 21.0007 9.33325C20.0802 9.33325 19.334 10.0794 19.334 10.9999C19.334 11.9204 20.0802 12.6666 21.0007 12.6666Z",
    fill: "#947BFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6637 15.3333H18.6696",
    stroke: "#947BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9976 15.3333H16.0036",
    stroke: "#947BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3297 15.3333H13.3357",
    stroke: "#947BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadRemind);
export default __webpack_public_path__ + "static/media/lead-remind.088203d57fd4640a84a5de051a668396.svg";
export { ForwardRef as ReactComponent };